import React, { useEffect } from 'react'
import { useState } from 'react'

// Components
import { Col, Form } from 'react-bootstrap'
import { RadioButton } from '../radio-button'
import { getOrdinal, getWeekdayNames } from '../utils'
import { RecurringSection } from './styles'

export const RecurrenceMonthly = ({ setMonthlyRecurrence }: any) => {
  const [recurrenceDate, setRecurrenceDate] = useState('day-of-month')

  const [dayOfMonth, setDayOfMonth] = useState<number>(1)
  const dayOfMonthOptions: number[] = Array.from({ length: 31 }, (_, i) => i + 1)

  const [dayOfWeek, setDayOfWeek] = useState<number>(1)
  const dayOfWeekOptions: number[] = Array.from({ length: 7 }, (_, i) => i)
  const weekNames = getWeekdayNames()

  const weekSegmentOptions = ['First', 'Second', 'Third', 'Fourth']
  const [weekSegment, setMonthSegment] = useState(weekSegmentOptions[0])

  useEffect(() => {
    var monthlyRecurrence: any = { recurrenceDate: recurrenceDate }
    if (recurrenceDate === 'day-of-month') {
      monthlyRecurrence['dayOfMonth'] = dayOfMonth
    } else if (recurrenceDate === 'month-segment') {
      monthlyRecurrence['weekSegment'] = weekSegment
      monthlyRecurrence['dayOfWeek'] = dayOfWeek
    }
    setMonthlyRecurrence(monthlyRecurrence)
  }, [dayOfMonth, dayOfWeek, recurrenceDate, weekSegment])

  return (
    <>
      <Form.Group as={Col} xl="9">
        <RecurringSection>
          <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => setRecurrenceDate('day-of-month')}>
            <RadioButton
              name="recurrenceDateOptions"
              value="day-of-month"
              checked={recurrenceDate === 'day-of-month'}
              onChange={(e: any) => setRecurrenceDate(e.target.value)}
            />
            <span style={{ fontWeight: '500', padding: '0 1em' }}>On the&nbsp;</span>
            <Form.Select
              value={dayOfMonth}
              onChange={(e) => setDayOfMonth(parseInt(e.target.value))}
              style={{ width: 140 }}
            >
              {dayOfMonthOptions.map((day: number, id: number) => (
                <option value={day} key={id}>
                  {getOrdinal(day)}
                </option>
              ))}
            </Form.Select>
            <span style={{ fontWeight: '500', padding: '0 1em' }}>&nbsp;of the month</span>
          </div>
          <div
            style={{ display: 'flex', alignItems: 'center', padding: '2em 0 0' }}
            onClick={() => setRecurrenceDate('month-segment')}
          >
            <RadioButton
              name="recurrenceDateOptions"
              value="month-segment"
              checked={recurrenceDate === 'month-segment'}
              onChange={(e: any) => setRecurrenceDate(e.target.value)}
            />
            <span style={{ fontWeight: '500', padding: '0 1em' }}>On the&nbsp;</span>
            <Form.Select
              value={weekSegment}
              onChange={(e) => setMonthSegment(e.target.value)}
              style={{ width: 100, marginRight: '.5em' }}
            >
              {weekSegmentOptions.map((weekNumber: string, id: number) => (
                <option value={weekNumber} key={id}>
                  {weekNumber}
                </option>
              ))}
            </Form.Select>
            <Form.Select
              value={dayOfWeek}
              onChange={(e) => setDayOfWeek(parseInt(e.target.value))}
              style={{ width: 140 }}
            >
              {dayOfWeekOptions.map((day: number, id: number) => (
                <option value={day} key={id}>
                  {weekNames[day]}
                </option>
              ))}
            </Form.Select>
            <span style={{ fontWeight: '500', padding: '0 1em' }}>&nbsp;of the month</span>
          </div>
        </RecurringSection>
      </Form.Group>
    </>
  )
}
